'use client';
import React from 'react';

const footerLinks = {
  producto: [
    { label: 'Características', href: '#caracteristicas' },
    { label: 'Precios', href: '#pricing' },
    { label: 'Demo', href: '#demo' },
    { label: 'Iniciar sesión', href: '/admin/login' },
    { label: 'Empezar gratis', href: '#pricing' },
  ],
  empresa: [
    { label: 'Acerca de BT SaaS', href: '#' },
    { label: 'BidTrek.com', href: 'https://bidtrek.com', external: true },
    { label: 'Contacto', href: 'mailto:hola@btsaas.com' },
    { label: 'Soporte', href: 'mailto:soporte@btsaas.com' },
  ],
  legal: [
    { label: 'Política de privacidad', href: '#' },
    { label: 'Términos de servicio', href: '#' },
    { label: 'Política de cookies', href: '#' },
  ],
};

export default function DriveXFooter() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id.replace('#', ''));
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer
      id="contacto"
      className="dx-font"
      style={{ background: '#0A0A0A', borderTop: '1px solid rgba(200,16,46,0.2)', padding: '48px 0' }}
    >
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10 mb-10">
          {/* Brand */}
          <div>
            <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 900, fontSize: '22px', color: '#FFFFFF', letterSpacing: '0.08em', marginBottom: '2px' }}>DriveX</div>
            <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 600, fontSize: '10px', color: '#888888', textTransform: 'uppercase', letterSpacing: '0.15em', marginBottom: '8px' }}>by BT SaaS</div>
            <p style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 400, fontSize: '12px', color: '#AAAAAA', marginBottom: '16px' }}>
              El sistema operativo para concesionarios premium.
            </p>
            <div style={{ display: 'flex', gap: '12px' }}>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" style={{ color: '#888888', fontSize: '18px', textDecoration: 'none', transition: 'color 0.2s' }}
                onMouseEnter={e => ((e.currentTarget as HTMLElement).style.color = '#FFFFFF')}
                onMouseLeave={e => ((e.currentTarget as HTMLElement).style.color = '#888888')}>
                📸
              </a>
              <a href={`https://wa.me/${process.env.NEXT_PUBLIC_BT_SAAS_WHATSAPP || '573000000000'}?text=Hola, quiero información sobre DriveX.`} target="_blank" rel="noopener noreferrer" style={{ color: '#888888', fontSize: '18px', textDecoration: 'none', transition: 'color 0.2s' }}
                onMouseEnter={e => ((e.currentTarget as HTMLElement).style.color = '#FFFFFF')}
                onMouseLeave={e => ((e.currentTarget as HTMLElement).style.color = '#888888')}>
                💬
              </a>
            </div>
          </div>

          {/* Producto */}
          <div>
            <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '10px', color: '#888888', textTransform: 'uppercase', letterSpacing: '0.12em', marginBottom: '12px' }}>PRODUCTO</div>
            {footerLinks.producto.map((link) => (
              <div key={link.label} style={{ marginBottom: '8px' }}>
                <a
                  href={link.href}
                  onClick={link.href.startsWith('#') ? (e) => { e.preventDefault(); scrollTo(link.href); } : undefined}
                  style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500, fontSize: '12px', color: '#AAAAAA', textDecoration: 'none', transition: 'color 0.2s' }}
                  onMouseEnter={e => ((e.currentTarget as HTMLElement).style.color = '#FFFFFF')}
                  onMouseLeave={e => ((e.currentTarget as HTMLElement).style.color = '#AAAAAA')}
                >
                  {link.label}
                </a>
              </div>
            ))}
          </div>

          {/* Empresa */}
          <div>
            <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '10px', color: '#888888', textTransform: 'uppercase', letterSpacing: '0.12em', marginBottom: '12px' }}>EMPRESA</div>
            {footerLinks.empresa.map((link) => (
              <div key={link.label} style={{ marginBottom: '8px' }}>
                <a
                  href={link.href}
                  target={(link as { external?: boolean }).external ? '_blank' : undefined}
                  rel={(link as { external?: boolean }).external ? 'noopener noreferrer' : undefined}
                  style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500, fontSize: '12px', color: '#AAAAAA', textDecoration: 'none', transition: 'color 0.2s' }}
                  onMouseEnter={e => ((e.currentTarget as HTMLElement).style.color = '#FFFFFF')}
                  onMouseLeave={e => ((e.currentTarget as HTMLElement).style.color = '#AAAAAA')}
                >
                  {link.label}
                </a>
              </div>
            ))}
          </div>

          {/* Legal */}
          <div>
            <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '10px', color: '#888888', textTransform: 'uppercase', letterSpacing: '0.12em', marginBottom: '12px' }}>LEGAL</div>
            {footerLinks.legal.map((link) => (
              <div key={link.label} style={{ marginBottom: '8px' }}>
                <a
                  href={link.href}
                  style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500, fontSize: '12px', color: '#AAAAAA', textDecoration: 'none', transition: 'color 0.2s' }}
                  onMouseEnter={e => ((e.currentTarget as HTMLElement).style.color = '#FFFFFF')}
                  onMouseLeave={e => ((e.currentTarget as HTMLElement).style.color = '#AAAAAA')}
                >
                  {link.label}
                </a>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{ borderTop: '1px solid #2A2A2A', paddingTop: '24px', display: 'flex', flexDirection: 'column', gap: '8px' }} className="md:flex-row md:justify-between">
          <span style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500, fontSize: '11px', color: '#888888' }}>
            © 2024 DriveX · BT SaaS · Una empresa de BidTrek. Todos los derechos reservados.
          </span>
          <span style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500, fontSize: '11px', color: '#888888' }}>
            Construido en Colombia 🇨🇴
          </span>
        </div>
      </div>
    </footer>
  );
}
